module.exports = __webpack_public_path__ + "static/media/canada-coat-of-arms.72ac32a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Network/canada-coat-of-arms.svg
// module id = 1124
// module chunks = 0